import { MockFactory } from '@tino-frontend/mocks'
import { MerchantStatus, MerchantProfile } from '@types'

export const merchantStatusAbleToTransactMock =
  new MockFactory<MerchantProfile>({
    id: '123',
    document_number: '86171838000163',
    company_name: 'John Wick Ltda. (fatura)',
    total_limit_cents: 50000,
    available_limit_cents: 25000,
    status: MerchantStatus.Allowed,
    users: [
      {
        email: 'testeg@teste.com.br',
      },
    ],
    is_able_to_transact: true,
  })

export const merchantStatusTermRequestedMock = new MockFactory<MerchantProfile>(
  {
    id: '123',
    document_number: '86171838000163',
    company_name: 'John Wick Ltda. (fatura)',
    total_limit_cents: 0,
    available_limit_cents: 0,
    status: MerchantStatus.RequestedTerms,
    users: [
      {
        email: 'testeg@teste.com.br',
      },
    ],
    is_able_to_transact: true,
  }
)

export const merchantStatusLimitPendingMock = new MockFactory<MerchantProfile>({
  id: '123',
  document_number: '86171838000163',
  company_name: 'John Wick Ltda. (fatura)',
  total_limit_cents: 0,
  available_limit_cents: 0,
  status: MerchantStatus.WaitingLimitAnalisys,
  users: [
    {
      email: 'testeg@teste.com.br',
    },
  ],
  is_able_to_transact: true,
})

export const merchantStatusKYCPendingMock = new MockFactory<MerchantProfile>({
  id: '123',
  document_number: '86171838000163',
  company_name: 'John Wick Ltda. (fatura)',
  total_limit_cents: 50000,
  available_limit_cents: 50000,
  status: MerchantStatus.PendingIdentification,
  users: [
    {
      email: 'testeg@teste.com.br',
    },
  ],
  is_able_to_transact: true,
})

export const merchantStatusTermRejectedMock = new MockFactory<MerchantProfile>({
  id: '123',
  document_number: '86171838000163',
  company_name: 'John Wick Ltda. (fatura)',
  total_limit_cents: 0,
  available_limit_cents: 0,
  status: MerchantStatus.RejectedTerms,
  users: [
    {
      email: 'testeg@teste.com.br',
    },
  ],
  is_able_to_transact: true,
})

export const merchantStatusLimitBlockedMock = new MockFactory<MerchantProfile>({
  id: '123',
  document_number: '86171838000163',
  company_name: 'John Wick Ltda. (fatura)',
  total_limit_cents: 0,
  available_limit_cents: 0,
  status: MerchantStatus.BlockedLimit,
  users: [
    {
      email: 'testeg@teste.com.br',
    },
  ],
  is_able_to_transact: true,
})
